(function () {
    'use strict';

    a3_cabin_reports.factory('GroundServicesFactory', GroundServicesFactory);
    /**
     * @memberOf CabinReports
     * @ngdoc factory
     * @name GroundServicesFactory
     * @description
     * Get Ground Services
     * @gnInject
     */

    function GroundServicesFactory(GenericService) {
        /**
        * Initialize the GroundServices
        * @memberof GroundServicesFactory
        */
        function GroundService() {
            this.Station = null;
        }

        var objType = 'groundServices';
        var objCallBack = GroundService;

        var service = {
            fromObjectList: fromObjectList,
            getGroundServicesFromStorage: getGroundServicesFromStorage,
            setGroundServicesToStorage: setGroundServicesToStorage,
            clearGroundServicesFromStorage: clearGroundServicesFromStorage,
            getGroundServicesByStation: getGroundServicesByStation,
            upsertGroundServices : upsertGroundServices
        };

        /**
         * Extend an array of Objects from the default GroundService Object
         * @memberof GroundServicesFactory
         * @param {Array} objList  an Array Of ground Services
         * @returns {Array} groundServices
         */
        function fromObjectList(objList) {
            return GenericService.fromObjectList(objList, objCallBack);
        }
        /**
        * Get ground services from local storage
        * @memberof GroundServicesFactory
        * @returns {Array} groundServices 
        */
        function getGroundServicesFromStorage() {
            return GenericService.list(objType, objCallBack);
        }

        /**
         * Save ground services to storage
         * @memberof GroundServicesFactory
         * @param {Array} List of ground services
         */
        function setGroundServicesToStorage(groundServices) {
            for (var i = 0; i < groundServices.length; i++) {
                for (var j = 0; j < groundServices[i].Services.length; j++){
                    // isDefault could be null
                    if (groundServices[i].Services[j].IsDefault)
                        groundServices[i].Services[j].Used = 1;
                    else
                        groundServices[i].Services[j].Used = 0;
                }
            }
            GenericService.saveAll(groundServices, objType, objCallBack);
        }

        /**
         * Remove the ground services from the local storage
         * @memberof GroundServicesFactory
         */
        function clearGroundServicesFromStorage() {
            GenericService.removeAll(objType, objCallBack);
        }


        /**
         * Get Ground Services of a current station from the local storage
         * @memberof GroundServicesFactory
         * @param {number} station 
         * @return {object} GroundServices 
         */
        function getGroundServicesByStation(station) {
            
            var objects = getGroundServicesFromStorage();
            if (objects == null)
                return [];

            var results = [];

            var arrayLength = objects.length;
            for (var i = 0; i < arrayLength; i++) {
                if (objects[i].Station == station) {
                    results = objects[i].Services;
                }
            }
            return results;
        }

        /**
         * Upsert ground services
         * @memberof GroundServicesFactory
         */
        function upsertGroundServices(groundServices) {
            var newStations = groundServices.map(x => x.Station);
            var servicesLS = this.getGroundServicesFromStorage();
            servicesLS = servicesLS.filter(x => !newStations.includes(x.Station));
            var updatedServicesList = servicesLS.concat(groundServices);
            setGroundServicesToStorage(updatedServicesList);
        }

        return service;
    }
})();